export class SearchResultService {
    constructor($resource, ApiService) {
        'ngInject';

        this.$resource = $resource;
        this.apiService = ApiService;

        this.searchResultsResourceUrl = this.apiService.getResourceUrl('search');
        this.searchResultsResource = this.$resource(this.searchResultsResourceUrl);
    }

    _getSearchResultsObject(data) {
        let obj = {};
        obj.results = this._getDetailsObject(data.values);
        if (data.count) {
            obj.count = data.count;
        }
        return obj;
    }

    _getDetailsObject(data) {
        return data.map(({ content_id, details, created_at, search_result_type }) => {
            return {
                contentId: content_id,
                details,
                createdAt: created_at,
                searchResultType: this._getSearchResultTypeObject(search_result_type)
            };
        });
    }

    _getSearchResultTypeObject({ type = false, slug = '', module_name = false , display_name = false }) {
        let obj = {};
        if (type) {
            obj.type = type;
            obj.slug = slug;
            (module_name) ? obj.moduleName = module_name : false;
            (display_name) ? obj.displayName = display_name : false;
        }
        return obj;
    }

    getSearchResults(searchKey, limit = 10, pageId = 1) {
        const promise = this.searchResultsResource.get({
            search_key: searchKey,
            page_id: pageId,
            limit
        }).$promise;

        return promise
            .then(details => this._getSearchResultsObject(details.data))
            .catch(err => {
                throw this.apiService.getErrorMessage(err);
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/search-result/search-result.service.js